import React from "react"

import classNames from "classnames"
import PropTypes from "prop-types"

import { ListItem } from "../../../common/ListItem"
import { MasonryGrid } from "../../../common/MasonryGrid/MasonryGrid"
import { TagCard } from "../../../common/TagCard"
import * as styles from "./TagPage.module.scss"

const TagPage = ({ tagItems, title }) => {
  return (
    <>
      {title && (
        <ListItem
          topBorder={true}
          leftBorder={false}
          rightBorder={false}
          size="large"
          tagName="h1"
        >
          Tag Results: {title}
        </ListItem>
      )}

      <div className={styles.outer}>
        <MasonryGrid isFull>
          {tagItems.map((work, index) => {
            return (
              <TagCard
                explicit={work.explicit}
                className={classNames(styles.item, [styles[work.type]])}
                key={`theme-item-${work.displayName}-${index}`}
                imageTabs={work.label ? [{ text: work.label }] : null}
                tags={work.tags}
                sanityImage={work.sanityImage}
                cloudinaryImage={work.cloudinary?.gatsbyImageData}
                to={work.to}
                alt={work.alt || work.displayName + " - " + work.title}
                itemSlug={work.itemSlug}
              ></TagCard>
            )
          })}
        </MasonryGrid>
      </div>
    </>
  )
}

TagPage.propTypes = {
  tagName: PropTypes.string,
}

export { TagPage }
